import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';

@HookClass('socket')
export class SocketHook extends BaseHook {

    @Hook('fccb1377-15d5-4320-82fa-13fecce01dc7')
    public emit(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('SocketService')
            .pipe(concatMap((service: any) => {
                return service.emit(inputArtifact.object.config.roomId, inputArtifact.object.config.event, inputArtifact.object.data, inputArtifact.object.config.broadcast);
            }))
            .pipe(map(() => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = inputArtifact.object.data;
                return outputArtifact;
            }));


    }

    @Hook('3b04ee0c-9049-4e16-b140-16fac6b22804')
    public connect(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('SocketService')
            .pipe(concatMap((service: any) => {
                return service.connect(inputArtifact.object.config.wss, inputArtifact.object.config.onMessageFlowId, inputArtifact.object.config.onDisconnectFlowId, inputArtifact.object.config.queueName, inputArtifact.object.config.socketId);
            }))
            .pipe(map((id: string) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = id;
                return outputArtifact;
            }));
    }

    @Hook('6ebe190e-abd7-48b6-b0b9-83cb1db7266f')
    public send(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('SocketService')
            .pipe(concatMap((service: any) => {
                return service.send(inputArtifact.object.config.id, inputArtifact.object.data);
            }))
            .pipe(map((data: any) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = data;
                return outputArtifact;
            }));
    }

}
